<template>
    <div v-if="loginState.isAuditor">
        <div class="row" v-if="loginState.isAdministrator">
            <div class="col-md-12">
                <b-button variant="primary" class="btn btn-primary float-right mb-1" v-on:click="add()">
                <i class="fa fa-plus"/>&nbsp;Skapa användare
                </b-button>
            </div>
        </div>
        <b-card>
            <b-form-group>
              <label for="companyDropdown">Företag</label>
              <br>
              <CompaniesDropDown @onCompanySelected="loadUsers" v-if="loginState.isSuperUser"/>

            </b-form-group>
            <b-form-checkbox v-model="showInactiveUsers" class="mb-1">
                Visa inaktiva användare
            </b-form-checkbox>
            <div slot="header">
                Användare
                <div class="card-header-actions">
                <b-spinner v-if="loading" class="mr-1" type="border" small />
                </div>
            </div>  

            <table class="table table-striped table-hover">
            <thead>
                <tr >
                  <th class="col-5">Namn</th>
                  <th class="col-3">Typ</th>
                  <th class="col-3">Roll</th>
                  <th class="col-2 text-center" v-if="loginState.isAdministrator">Radera</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in sortedUsers" :key="user.id" style="cursor:pointer">
                    <td v-on:click="edit(user)" class="col-5">{{user.firstName}} {{user.lastName}}</td>
                    <td v-on:click="edit(user)" v-if="user.isEmployee" class="col-3">Anställd</td>
                    <td v-on:click="edit(user)" v-else class="col-3">Användare</td>
                    <td v-on:click="edit(user)" class="col-3">{{user.role}}</td>
                    <td class="col-2 col-lg-1 text-center" v-if="loginState.isAdministrator">
                        <i class="fa fa-trash-o fa-lg" v-on:click="remove(user)"></i>
                    </td>          
                </tr>
            </tbody>
            </table>            
        </b-card>
    </div>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { userService, companyService } from "../../shared/services";
import CompaniesDropDown from '../components/CompaniesDropDown'

export default {
  components: {
    CompaniesDropDown
  },  
  created() {
    this.loginState.init();
  }, 
  computed: {
    sortedUsers() {
      if(this.showInactiveUsers)
        return this.users;

      if(!this.users) return [];

      return this.users.filter(f => f.isActive);
    },
    selectedCompanyName() {
      return this.selectedCompany ? this.selectedCompany.name : this.loginState.user.companyName;
    }
  },    
  data() {
    return {
      selectedCompany: null,
      companies: null,
      loading: false,
      users: null,
      selectedUser: null,
      showInactiveUsers: false
    };
  },     
  mounted() {
    this.loading = true;
    
    if(!this.$route.query.companyId) {
      userService.get().then(users => {
        this.users = users;
        this.loading = false;
        }).catch(() => {
          this.ShowToast("Fel", "Ett okänt fel uppstod då användare skulle hämtas", "danger")
        }); 
    }
    else {
      companyService.getCompanyUsers(this.$route.query.companyId).then(p => {
        this.users = p;
        this.loading = false;
      }).catch(() => {
          this.ShowToast("Fel", "Ett okänt fel uppstod då användare skulle hämtas", "danger")
          this.loading = false;
        });
    }


  },
  methods:{
    add: function() {
      this.$router.push({ path: `/administration/users/0` });
    },    
    edit: function(user) {
      globalStore.selectedUser = user;
      this.$router.push({ path: `/administration/users/${user.id}?employee=${user.isEmployee}` });
    },
    loadUsers(company) {
      this.selectedCompany = company;
      this.loading = true;
      companyService.getCompanyUsers(company.id).then(p => {
        this.users = p;
        this.loading = false;
      }).catch(() => {
          this.ShowToast("Fel", "Ett okänt fel uppstod då användare skulle hämtas", "danger")
          this.loading = false;
        })
    },
    remove(user) {
      this.$bvModal.msgBoxConfirm(`Är du säker på att du vill radera användaren '${user.firstName} ${user.lastName}'?`).then(p => {
        if(!p) return;

        userService.deleteUser(user.id).then(p => {
          var index = this.users.indexOf(user);
          this.users.splice(index, 1);
          this.ShowToast("Raderad", "Användaren raderades", "success");
        }).catch(p => {
          if(p.status === 409) {
            this.ShowToast("Fel", "Användaren kan inte raderas då relationer till denne existerar. Välj att inaktivera användaren istället.", "danger");
            return;
          }
          this.ShowToast("Fel", "Ett okänt fel uppstod då användare skulle raderas", "danger")
        })
      })

    }
  }

}
</script>

<style>

</style>
